import { useCallback } from 'react';

import { useCurrentUser } from 'Auth';

export const useIsOwn = () => {
  const user = useCurrentUser();

  return useCallback(
    ({ id }) => {
      return id === user?.id;
    },
    [user]
  );
};
